import 'whatwg-fetch'
import Dialog from '../dialog';
import Overflow from '../overflow';
import Pager from '../paging';
import Showhide from '../showhide';
import ZipcodeAutocomplete from '../zipcode-autocomplete';

export default class Filter {
    constructor (component) {
        this.component = component;
        this.pager = null;
        this.loader = document.createElement('div');
        this.loader.classList.add('loader');
        this.loading = false;

        const searchParams = new URLSearchParams(window.location.search);
        this.page = parseInt(searchParams.get('page'), 10) || 1;
        this.opencategories = searchParams.get('opencategories') ? searchParams.get('opencategories').split(',') : [];
        this.currentFilters = Object.fromEntries(searchParams) || {};

        this.bindHandlers();
    }

    bindHandlers() {
        this.pager = new Pager(this.component.querySelector('[data-filter-paging]'));
        this.filterSubmit = this.component.querySelector('[data-filter-apply]');
        this.filterDialog = this.component.querySelector('#filters');
        this.overflowComponent = this.component.querySelector('[data-component="overflow"]');
        this.zipcodeBox = this.component.querySelector('[data-zipcode-autocomplete]')
        
        Array.prototype.forEach.call(this.component.querySelectorAll('[data-component="showhide"]'), showhideTrigger => new Showhide(showhideTrigger));

        if (this.filterSubmit) {
            this.filterSubmit.addEventListener('click', (e) => {
                e.preventDefault();

                this.page = 1;
                this.filter();
            });
        }

        if (this.filterDialog) {
            new Dialog(this.filterDialog);
        }

        if (this.zipcodeBox) {
            new ZipcodeAutocomplete(this.zipcodeBox);
        }

        if (this.pager.el) {
            this.pager.el.addEventListener('onPage', (e) => {
                this.page = e.detail.page;
                this.filter();
            });
        }

        this.showmoreTriggers = this.component.querySelectorAll('[data-filter-showmore]');
        this.showmoreTriggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                this.opencategories.push(trigger.getAttribute('data-filter-showmore'));
            });
        });

        this.checkboxes = [...this.component.elements].filter(x => x.type === 'checkbox');
        this.checkboxes.forEach((s) => {
            s.addEventListener('change', () => {
                // Don't filter immediately on change event on mobile (when filters are shown in an overlay)
                if (matchMedia('(min-width: 992px)').matches || s.closest('.checkbox').classList.contains('checkbox--tile')) {
                    this.page = 1;
                    this.filter();
                }   
            });
        });
    }

    serializeFormData(form) {
        const responseObject = {};
        const fieldNames = [];

        [...form.elements].forEach(function (field) {
            if (fieldNames.includes(field.name) || !field.name || field.disabled || (field.type !== 'checkbox' && field.type !== 'text') ) return;

            responseObject[field.name] = [];

            [...form.elements].filter(x => x.name === field.name).forEach(correspondingField => {
                if (field.type === 'checkbox') {
                    if (correspondingField.checked) responseObject[field.name].push(correspondingField.value);
                } else {
                    responseObject[field.name] = (correspondingField.value);
                }
            });

            fieldNames.push(field.name);
        });

        return responseObject;
    }

    getUrlParams() {
        const params = new URLSearchParams(this.currentFilters);
        return params.toString();
    }

    updateUrl () {
        history.pushState(null, '', `${document.location.pathname}?${this.getUrlParams()}`);
    }

    addLoader() {
        this.component.classList.add('is-loading');
        this.component.appendChild(this.loader);
    }

    removeLoader() {
        this.component.classList.remove('is-loading');
        this.component.removeChild(this.loader);
    }

    filter() {
        const opencategoriesData = Array.isArray(this.opencategories) ? this.opencategories.join(',') : this.opencategories;
        this.currentFilters = {
            ...this.serializeFormData(this.component),
            page: this.page,
            opencategories: opencategoriesData
        }

        this.loading = true;
        this.addLoader();

        fetch(this.component.action, {
            method: 'POST',
            headers: {
                'Content-Type': 'text/html; charset=UTF-8',
                'Accept-Language': document.documentElement.lang,
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(this.currentFilters),
            credentials: 'same-origin',
        })
            .then(response => response.text())
            .then(html => {
                this.removeLoader();

                this.component.innerHTML = html;

                this.updateUrl();
                this.bindHandlers();

                if (this.overflowComponent) {
                    new Overflow(this.overflowComponent);
                }
            });
    }
}